import { render, staticRenderFns } from "./BlockIcon.vue?vue&type=template&id=f328a77e"
import script from "./BlockIcon.vue?vue&type=script&lang=js"
export * from "./BlockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports